import {Route, Routes} from "react-router-dom";
import {Home} from "../../pages/home/Home";
import {BaseLayout} from "../baseLayout/BaseLayout";
import {Login} from "../../pages/login/Login";
import {DesktopPage} from "../../pages/desktop/DesktopPage";
import Dossier from "../../pages/dossier/Dossier";
import Settings from "../../pages/settings/Settings";
import Cruscotto from "../../pages/cruscotto/Cruscotto";
import UserDetails from "../../pages/userDetails/UserDetails";
import PracticesPage from "../../pages/practices/PracticesPage";
import {RoutingURL} from "../../model/models";
import Activity from "../../pages/activity/Activity";
import DocumentsManagement from "../../pages/settings/DocumentsManagement/DocumentsManagement";
import VariablesManagement from "../../pages/settings/VariablesManagement/VariablesManagement";
import NonPaymentAlertPage from "../../pages/non-payment-alert/NonPaymentAlertPage";
import Users from "../../pages/settings/Users/Users";
import Reports from "../../pages/Reports/Reports";
import ReportChiamate from "../../pages/Reports/ReportChiamate/ReportChiamate";
import ReportRate from "../../pages/Reports/ReportRate/ReportRate";
import ReportIncassi from "../../pages/Reports/ReportIncassi/ReportIncassi";
import Profile from "../profile/Profile";

export function Routing(){
    return <Routes>

        <Route path={RoutingURL.LOGIN} element={<Login />} ></Route>

        <Route element={<BaseLayout />}>
            <Route path={RoutingURL.HOME} element={<Home />} ></Route>
            <Route path={RoutingURL.SCRIVANIA} element={<DesktopPage />} ></Route>
            <Route path={RoutingURL.CRUSCOTTO} element={<Cruscotto />} ></Route>
            <Route path={RoutingURL.DOSSIER} element={<Dossier />} ></Route>
            <Route path={RoutingURL.SETTINGS} element={<Settings />} ></Route>
            <Route path={RoutingURL.PRACTICES} element={<PracticesPage />} ></Route>
            <Route path={RoutingURL.USERDETAILS} element={<UserDetails />} ></Route>
            <Route path={RoutingURL.USERDETAILSPRACTICES} element={<UserDetails />} ></Route>
            <Route path={RoutingURL.REPORT} element={<Reports />} ></Route>
            <Route path={RoutingURL.REPORT_CHIAMATE} element={<ReportChiamate />} />
            <Route path={RoutingURL.REPORT_RATE} element={<ReportRate />} />
            <Route path={RoutingURL.REPORT_INCASSI} element={<ReportIncassi />} />
            <Route path={RoutingURL.MODULES} element={<DocumentsManagement />} />
            <Route path={RoutingURL.VARIABLES} element={<VariablesManagement />} />
            <Route path={RoutingURL.ACTIVITY} element={<Activity />} />
            <Route path={RoutingURL.AVVISO} element={<NonPaymentAlertPage />} />
            <Route path={RoutingURL.USERS} element={<Users />} />
            <Route path={RoutingURL.PROFILE} element={<Profile />} />

        </Route>

    </Routes>
}